// extracted by mini-css-extract-plugin
module.exports =  {"disabled":"RouterLink__disabled--qh"};